import Typography from "@material-ui/core/Typography";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import {Box, Button, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import {useEffect, useState} from "react";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate,
    convertToMobileNumber
} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {LoansService} from "../LoinsList/LoansService";
import ListOfAccounts from "../../component/ListOfAccounts/ListOfAccounts";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";


const ADDNewLoans = ({openDialog, handleClose, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new LoansService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getLoanKinds();
        }
    }, [])

    function getLoanKinds() {
        service.getLoanKinds()
            .then(response => {
                setLoanKinds(response)
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت انواع وام ها!"))
        })
    }

    const [state, setState] = useState(1);
    const [subTitleMessage, setSubTitleMessage] = useState("");
    const [nextStateButtonTitle, setNextStateButtonTitle] = useState("");
    const [backBtnTitle, setBackBtnTitle] = useState("");

    const [headerFieldTitle, setHeaderFieldTitle] = useState("");

    //userInfoState
    const [userId, setUserId] = useState("");
    const [userNameLastName, setUserNameLastName] = useState("");
    const [userPersonalCode, setUserPersonalCode] = useState("");
    const [userPhoneNumber, setUserPhoneNumber] = useState("");
    const [userGroupName, setUserGroupName] = useState("");

    const [loanAmount, setLoanAmount] = useState("");
    const [loanInstallments, setLoanInstallments] = useState("");
    const [loadPayDate, setLoadPayDate] = useState("initState");

    const [loanInstallmentsList, setLoanInstallmentsList] = useState([]);

    const [selectedLoanKinds, setSelectedLoanKinds] = useState(-1);
    const [loanKinds, setLoanKinds] = useState([]);

    const [loanIsChecked, setLoanIsChecked] = useState(false);

    const [submitPaidForAll, setSubmitPaidForAll] = useState(false);

    useEffect(() => {
        switch (state) {
            case 1 :
                setSubTitleMessage("لطفا عضو مورد نظر را انتخاب نمایید.")
                setHeaderFieldTitle("اطلاعات عضو")
                setNextStateButtonTitle("ثبت و ادامه")
                setBackBtnTitle("بازگشت")
                break;
            case 2 :
                setSubTitleMessage("لطفا اطلاعات حساب را تکمیل نمایید.")
                setNextStateButtonTitle("ثبت و افزودن وام")
                setBackBtnTitle("بازگشت به انتخاب عضو")

                setLoanAmount("")
                setLoadPayDate("")
                setLoanInstallments("")
                setLoanInstallmentsList([])

                break;
            default:
                setSubTitleMessage("")
                setNextStateButtonTitle("ثبت و ادامه")
                setBackBtnTitle("بازگشت")
        }

    }, [state])

    useEffect(() => {
        if (openDialog) {
            clearUserFields()
            clearCashAccountFields()
        }

    }, [openDialog])


    function handleBackClicked() {
        switch (state) {
            case 1:
                handleClose()
                break
            case 2:
                setState(1)
                break
            case 3:
                setState(2)
                break
            default:
                setState(1)
        }
    }

    function handleGoNextStateClicked() {
        switch (state) {
            case 1:
                if (parseInt(userId) >= 0)
                    setState(2)
                else
                    snackbar(setSnackbarDispatch(
                        SnackbarActionTypes.SHOW_WARNING,
                        "لطفا عضو مورد نظر را انتخاب نمایید!"))
                break
            case 2: {
                if (loanIsChecked) {
                    needRefresh(true)
                    createLoan()
                } else {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا ابتدا وام را محاسبه و بررسی نمایید!"))
                }
                break
            }
            default:
                setState(1)
        }
    }

    function createLoan() {

        loading(setLoadingStateDispatch(true))
        service.createLoan(fundID, userId, loanAmount, loanInstallments, selectedLoanKinds, loadPayDate, submitPaidForAll)
            .then(response => {
                clearUserFields()
                clearCashAccountFields()
                setState(1)
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "وام جدید با موفقیت ساخته شد."))
                handleClose()
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در ایجاد وام جدید!",snackbar,loading)
        })
    }

    function selectUserRowClicked(rowInfo) {
        if (state === 1) {
            setUserId(rowInfo.id)
            setUserNameLastName(rowInfo.name)
            setUserPhoneNumber(rowInfo.phoneNumber)
            setUserPersonalCode(rowInfo.personalCode)
            setUserGroupName(rowInfo.group)

        } else if (state === 2) {

        }
    }

    function clearUserFields() {
        setUserId("")
        setUserNameLastName("")
        setUserPhoneNumber("")
        setUserPersonalCode("")
        setUserGroupName("")

        setLoanAmount("")
        setLoadPayDate("")
        setLoanInstallments("")
        setLoanInstallmentsList([])

    }

    function clearCashAccountFields() {
        setLoanAmount("")
        setLoanInstallments("")
        setLoadPayDate("")
    }

    function handleCalculateLoan() {
        if (checkFields()) {
            setLoanIsChecked(true)
            setLoanInstallmentsList([])
            loading(setLoadingStateDispatch(true))
            service.calculateLoan(fundID, userId, loanAmount, loanInstallments, selectedLoanKinds, loadPayDate)
                .then(response => {
                    setLoanInstallmentsList(response.installments)
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در آماده سازی وام...",snackbar,loading)
            })
        }
    }

    function checkFields() {
        let message = ""
        let state = true

        if (loanAmount === '' || loanAmount === "0") {
            state = false
            message = "لطفا مقدار وام را وارد نمایید!"
        } else if (loadPayDate.length !== 10) {
            state = false
            message = "لطفا تاریخ پرداخت وام را به درستی وارد نمایید!"
        } else if (loanInstallments === '' || loanInstallments === "0") {
            state = false
            message = "لطفا تعداد اقساط وام را به درستی وارد نمایید!"
        }

        if (message.length > 0)
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }

    function changePaymentStringState(id) {
        const element = document.getElementById(`InstallmentsState${id}`)
        if (element && element.checked) {
            document.getElementById(`transactionStringState${id}`).innerHTML = "پرداخت شده"
            document.getElementById(`transactionStringState${id}`).className = "cardCustomDescription bg_active_state"
        } else {
            document.getElementById(`transactionStringState${id}`).innerHTML = "پرداخت نشده"
            document.getElementById(`transactionStringState${id}`).className = "cardCustomDescription bg_deActive_state"
        }
    }

    return (
        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <section className="pageContainer">
                <Box className="transactionHeader">
                    <section className="transactionTitle">
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6}
                              className="d-flex flex-column flex-nowrap justifyContentCenter">
                            <Typography variant={"h6"}>
                                {subTitleMessage}
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6} className="d-flex flex-row justifyContentEnd mt-2">
                            <Grid>
                                <button className="btn-secondary me-2 " onClick={handleBackClicked}>
                                    {backBtnTitle}
                                </button>
                            </Grid>
                            <Grid>
                                <button className="btn-confirm" onClick={handleGoNextStateClicked}>
                                    {nextStateButtonTitle}
                                </button>
                            </Grid>
                        </Grid>
                    </section>
                    <Box style={{display: "flex", flexWrap: "wrap"}} className={`${state === 2 ? "d-none" : ""}`}>
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                            <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                {headerFieldTitle}
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={userId}
                                disabled={true}
                                className='w-100'
                                variant="outlined" label="شماره حساب"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={userNameLastName}
                                disabled={true}
                                className='w-100'
                                variant="outlined" label="نام و نام خانوادگی"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={userPersonalCode}
                                className='w-100'
                                disabled={true}
                                dir={"ltr"}
                                variant="outlined" label="کد ملی"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={userGroupName}
                                className='w-100'
                                disabled={true}
                                variant="outlined" label="گروه"/>
                        </Grid>
                    </Box>
                </Box>
                <Box className="d-flex flex-column mt-2" style={{padding: "0.5rem 3rem", overflowY: "auto"}}>
                    {state === 1 ?
                        <ListOfAccounts
                            isMain={false}
                            rowOnClicked={selectUserRowClicked}/> :
                        <Box className="d-flex flex-row flex-wrap w-100">
                            <Grid xs={12} xl={12} className="w-100 p-2">
                                <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                    مشخصات مالک وام
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userNameLastName}
                                    disabled={true}
                                    className='w-100'
                                    variant="outlined" label="نام و نام خانوادگی"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userPersonalCode}
                                    className='w-100'
                                    disabled={true}
                                    dir={"ltr"}
                                    variant="outlined" label="کد ملی"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={convertToMobileNumber(userPhoneNumber)}
                                    className='w-100'
                                    disabled={true}
                                    dir={"ltr"}
                                    variant="outlined" label="شماره همراه"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userGroupName}
                                    className='w-100'
                                    disabled={true}
                                    variant="outlined" label="گروه"/>
                            </Grid>

                            <Grid xs={12} xl={12} className="w-100 p-2">
                                <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                    اطلاعات وام
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={6} md={8} lg={4} xl={4} className="w-100 p-2">
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">نوع وام</InputLabel>
                                    <Select value={selectedLoanKinds} onChange={e => {
                                        setLoanIsChecked(false)
                                        setSelectedLoanKinds(e.target.value)
                                    }} label="نوع وام">
                                        {loanKinds.map((item, index) => {
                                            return <option className="px-2 py-1" value={item.id}>
                                                {item.persianName}
                                            </option>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={6} md={4} lg={2} xl={2} className="w-100 p-2">
                                <TextField
                                    value={convertCurrencyFormat(loanAmount)}
                                    onChange={e => {
                                        setLoanIsChecked(false)
                                        const num = e.target.value.replaceAll(",", "")
                                        setLoanAmount(num)
                                    }}
                                    className='w-100'
                                    dir={"ltr"}
                                    variant="outlined" label="مبلغ وام (ریال)"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={4} lg={2} xl={2} className="w-100 p-2">
                                <TextField
                                    value={convertToBirthDate(loadPayDate)}
                                    onChange={e => {
                                        setLoanIsChecked(false)
                                        setLoadPayDate(convertToBirthDate(e.target.value))
                                    }}
                                    placeholder="1400/01/01"
                                    className='w-100'
                                    dir={"ltr"}
                                    variant="outlined" label="تاریخ پرداخت"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={4} lg={2} xl={2} className="w-100 p-2">
                                <TextField
                                    value={convertCurrencyFormat(loanInstallments)}
                                    onChange={e => {
                                        setLoanIsChecked(false)
                                        const num = e.target.value.replaceAll(",", "")
                                        if (num.length === 0 || parseInt(num) <= 100)
                                            setLoanInstallments(num)
                                    }}
                                    size={3}
                                    className='w-100'
                                    dir={"ltr"}
                                    variant="outlined" label="تعداد اقساط"/>
                            </Grid>

                            {/*<Grid xs={12} sm={6} md={4} lg={2} xl={2} className="w-100 p-2">
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">پرداخت اقساط</InputLabel>
                                    <Select label="پرداخت اقساط"
                                            value={submitPaidForAll}
                                            onChange={e => {
                                                setSubmitPaidForAll(e.target.value)
                                            }}
                                    >
                                        <option value={true}>پرداخت همه اقساط</option>
                                        <option value={false}>بدون پرداخت اقساط</option>
                                    </Select>
                                </FormControl>
                            </Grid>*/}
                            <Grid xs={12} sm={6} md={4} lg={2} xl={2} className="w-100 p-2">
                                <Button className="btn-confirm w-100" onClick={handleCalculateLoan}>
                                    محاسبه وام
                                </Button>
                            </Grid>
                            {
                                loanInstallmentsList.map((item, index) => {
                                    return <Box className="cardCustom">
                                        <Grid xs={6} sm={4} md={4} lg={1} xl={1}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">شماره قسط</span>
                                            <span
                                                className="cardCustomDescription">{item.numberOfInstallment}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">کارمزد (ریال)</span>
                                            <span
                                                className="cardCustomDescription">{
                                                convertCurrencyFormatPositiveNegative(item.amountOfCommission > 0 ? item.amountOfCommission : "0")}
                                            </span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ (ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.amount)}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ کمکی (ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.auxiliaryAmount > 0 ?
                                                item.auxiliaryAmount : "0")}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">مبلغ پرداختی(ریال)</span>
                                            <span
                                                className="cardCustomDescription">{convertCurrencyFormatPositiveNegative(item.payableAmount)}</span>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={4} lg={2} xl={2}
                                              className="cardCustomContent p-2 w-100">
                                            <span className="cardCustomTitle">سررسید</span>
                                            <span
                                                className="cardCustomDescription">{moment(item.date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}</span>
                                        </Grid>
                                    </Box>
                                })
                            }
                        </Box>}
                </Box>

            </section>
        </Dialog>

    )
};

export default ADDNewLoans;